import FullImage from "./full-image.component";

export default FullImage;
